module.exports = __webpack_public_path__ + "img/turkey.251e4939.png";